import { render, staticRenderFns } from "./AdManagementPolicy.vue?vue&type=template&id=327fe5f8&scoped=true&"
import script from "./AdManagementPolicy.vue?vue&type=script&lang=js&"
export * from "./AdManagementPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AdManagementPolicy.vue?vue&type=style&index=0&id=327fe5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327fe5f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('327fe5f8', component.options)
    } else {
      api.reload('327fe5f8', component.options)
    }
    module.hot.accept("./AdManagementPolicy.vue?vue&type=template&id=327fe5f8&scoped=true&", function () {
      api.rerender('327fe5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/adsetprotos/AdManagementPolicy.vue"
export default component.exports